// extracted by mini-css-extract-plugin
export var aggregationCell = "_2d-h";
export var aggregationRow = "_2d-g";
export var borderlessSpinnerContainer = "_2d-2";
export var closeIcon = "_2d-9";
export var expandIcon = "_2d-a";
export var expanded = "_2d-b";
export var filterDropdown = "_2d-c";
export var filterDropdownDivider = "_2d-7";
export var filterDropdownHeader = "_2d-f";
export var filterDropdownItem = "_2d-e";
export var filterDropdownModal = "_2d-d _2d-c";
export var filterItem = "_2d-6";
export var normalCellWithAdjustableBorder = "_2d-8";
export var pinButtonContainer = "_2d-i";
export var pinIcon = "_2d-j";
export var pinIconActive = "_2d-k";
export var spinner = "_2d-0";
export var spinnerContainer = "_2d-1";
export var tableContainer = "_2d-3";
export var tableContentInner = "_2d-5";
export var tableContentWrapper = "_2d-4";
export var viewButtonContainer = "_2d-l";